<template>
<div>
	<Modal
    v-model="showModal"
    width="600"
    :mask-closable="false"
    class-name="cer-modal"
  >
	<!-- :closable="false" -->
    <p slot="header">
      <span style="display: inline-block;margin-top: 3px;color:#000;font-weight: normal;">{{ title[isShow] }}</span>
      <img src="./../images/elogo.png" class="logo" v-if="isShow == 3" />
    </p>
    <!-- 通告 -->
    <div class="content" v-if="isShow == 1">
      尊敬的客户：
      <div class="txt">
        您好，因上级监管部门要求，为了保证贵司账号安全，避免产生法律风险。我司不得不对您公司进行企业实名认证。
      </div>
      <div class="txt" v-if="date>0">
        请在<span class="warning">{{date}}日</span
        >内完成企业认证，如未完成将会影响贵公司正常下单。
      </div>
      <div class="txt warning" v-if="date < 1">您的下单已被限制，请去完成企业实名认证。</div>
      <div class="txt">给贵司带来的不便敬请谅解，谢谢！</div>
    </div>
    <!-- 选择身份 -->
    <!-- <div class="content" v-if="isShow == 2" style="text-align: center">
      <div
        :class="identity == 1 ? 'choose active' : 'choose'"
        @click="identity = 1"
      >
        我是法人
      </div>
      <div
        :class="identity == 2 ? 'choose active' : 'choose'"
        @click="identity = 2"
      >
        我不是法人
      </div>
    </div> -->
    <!-- 声明 -->
    <div class="content" v-if="isShow == 3">
      <!-- <div class="txt">
        此次认证由鸭嘴兽委托 “e签宝”
        和专业第三方CA认证机构完成，将按照国家法律法规相关条款的规定严格保护您的隐私。
      </div>
      <div class="txt">
        “e签宝”
        是指：杭州天谷信息科技有限公司运营的平台，是专业电子签名技术服务提供商。您授权将本人的身份信息资料提交给
        “e签宝” 和第三方CA认证机构，鸭嘴兽将不参与此次认证，所有 认证将在
        “e签宝” 平台上完成。
      </div> -->
      <div class="txt">
        应监管部门要求，为了保证贵司账号安全，避免产生法律风险，贵公司需要在网站进行企业实名认证。我们将采取对公打款认证，授权书认证或法定代表人认证的方式来验证您的本人与企业的身份，您的个人与企业信息将得到绝对的保护。
      </div>
    </div>
    <!-- 企业实名认证 -->
    <div class="content" v-if="isShow == 4">
      <Steps :current="current" style="padding-left: 120px;">
        <Step title="个人实名认证"></Step>
        <Step title="企业实名认证" style="width: 30%"></Step>
      </Steps>
      <div style="text-align: center;margin-top:30px;font-size:18px" v-if="current == 1 || current == 2">
        <p v-if="current == 1">个人实名认证成功！</p>
        <p v-if="current == 2">企业实名认证成功！</p>
      </div>
    </div>
    <!-- 移出人员 -->
    <div class="content" v-if="isShow == 5">
      <Table
        :columns="table.columns"
        :data="table.data"
        height="200"
        no-data-text="暂无数据"
      ></Table>
    </div>
    <!-- 新建账号 -->
    <div class="content" v-if="isShow == 6">
      <Form ref="subForm" :model="subForm" :rules="subFormRules">
        <FormItem prop="name" label="姓名" :label-width="150">
          <Input
            type="text"
            v-model="subForm.name"
            placeholder="请输入姓名"
          />
        </FormItem>
        <FormItem prop="phone" label="手机号码" :label-width="150">
          <Input
            type="text"
            v-model="subForm.phone"
            placeholder="请输入手机号"
            style="width: "
          />
        </FormItem>
      </Form>
    </div>
    <!-- 创建账号成功 -->
    <div class="content" v-if="isShow == 7">
      <div class="p-l50">
        <i class="iconfont iconren"></i>
        <span class="label">用户名：</span>
        <span class="info">{{subForm.name}}</span>
      </div>
      <div class="p-l50">
        <i class="iconfont icondianhua"></i>
        <span class="label">手机号：</span>
        <span class="info">{{ subForm.phone }}</span>
      </div>
      <!-- <div class="p-l50">
        <i class="iconfont iconmima"></i>
        <span class="label">登录密码：</span>
        <span id="pwdp" class="info">{{ subForm.password }}</span>
        <i class="iconfont iconfuzhi" @click="copyPassword()" />
        <input id="pwd" class="info" v-model="subForm.password" />
      </div> -->
      <div class="p-l50">请贵司法人登录账号后完成企业认证操作</div>
    </div>
    <div slot="footer">
      <Button type="primary" @click="next">{{btnTxt}}</Button>
    </div>
  </Modal>
	<new-modal ref="newModal" :type="newModalInfo.type" :messageInfo="newModalInfo.messageInfo" :isConfirm="newModalInfo.isConfirm" @onOk="newModalInfo.onOk"  :okBtnText="newModalInfo.okBtnText" />
</div>
</template>

<script>
import { api } from "../api/register.js";
import moment from "moment";
import util from "@/libs/util";
import Cookies from 'js-cookie'
import _ from "lodash"
import newModal from './new-modal'
import {
  userInfo,
  userAuthUrl,
  userAuthStatus,
  orgAuthUrl,
	orgAuthStatus,
	createCompanyUser,
	remain,
	characterUpdate,
	removeCompany,
} from "@/api/certification";
import { getCompanyMember } from '@/api/home'
import { encrypt, decode } from "@/libs/encrypt-and-decode.js"
export default {
	props: {},
	components:{
		newModal
	},
  data() {
    const tableHead = () => {
      return [
        {
          title: "姓名",
          key: "name",
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row.name);
          },
        },
        {
          title: "联系电话",
          key: "phone",
          align: "center",
        },
        {
          title: "加入时间",
          key: "creationTime",
          align: "center",
          render: (h, params) => {
            let time = moment(params.row.creationTime).format("YYYY-MM-DD");
            return h("span", {}, time);
          },
        },
        {
          title: "公司角色",
          key: "characterPosition",
          align: "center",
          width: 130,
          render: (h, params) => {
						let selectArr=["老板","销售","操作","其他"]
						selectArr.map((item) => {
							if (item.label != params.row.characterPosition){
								selectArr.push(params.row.characterPosition)
							}
						})
						let arr = [...new Set(selectArr)]
            return h(
              "Select",
              {
                props: {
                  value: params.row.characterPosition,
                  label: params.row.characterPosition,
                },
                on: {
                  "on-change": (v) => {
										this.setCharacterUpdate(params.row.id, v)
                  },
                },
              },
              arr.map((item) => {
                return h("Option", {
                  props: {
                    value: item,
                    label: item,
                  },
                });
              })
            );
          },
        },
        {
          title: "操作",
          key: "",
					align: "center",
					width:80,
          render: (h, params) => {
            if (this.table.data.length > 1 && this.legal) {
							if(decode(Cookies.get('user')) != params.row.id){
								return h(
                "a",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  on: {
                    click: () => {
											this.newModalInfo = {
                        type:'warning',
                        messageInfo:`确定移出当前企业?`,
                        isConfirm: true,
                        onOk:()=>{
													removeCompany({
														"characterPosition": params.row.characterPosition,
														"id": params.row.id
													}).then( res => {
														if(res && res.data.success){
                              this.$Message.success('移出成功')
                              this.$refs['newModal'].show(false)
                              this.table.data.forEach((v,index) => {
                                if(v.id == params.row.id){
                                  this.table.data.splice(index,1)
                                }
                              });
														}else {
															this.$Message.error(res.data.msg)
														}
													})
												}
                      }
                      this.$refs['newModal'].show()
                    },
                  },
                },
                "移出"
              	)
							}else {
								return h('span', {}, '移出')
							}
						}
          },
        },
      ];
    };
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
        this.showLogin = false;
      } else if (!/^[1-9][0-9]{10}$/.test(value)) {
        callback(new Error("请输入正确手机号"));
        this.showLogin = false;
      } else {
        util.ajax_get(
          this,
          "/harbour-server/duckBill/valid/userId",
          { mobilePhone: value },
          (res) => {
            if (!res.data.success) {
              callback(new Error(res.data.message));
            } else {
              callback();
            }
          }
        );
      }
    };
    return {
			newModalInfo:{
        type:'warning',
        isConfirm: true,
        okBtnText:'',
        newModalInfo:'',
        onOk:()=>{}
      },
			btnTxt:'',
      isShow: 0,
      title: {
        1: "提示",
        2: "选择您的身份",
        3: "声明",
        4: "企业实名认证",
        5: "请确认以下用户是否为贵公司人员：",
        6: "请输入法人信息，系统将自动为您创建法人账号",
        7: "恭喜您，的账号已成功创建。",
      },
      identity: 0, //身份
      current: 0, //认证进度
      showModal: false,
      table: {
        columns: tableHead(),
        data: [],
			},
      subForm: {
        characterPosition: "其他",
        companyId:null,
        email: "",
        id: null,
        mailReminder: false,
        name: null,
        password: null,
        phone: null,
        qq: "",
        wechatReminder: false,
      },
      subFormRules: {
        name: { required: true, message: "请输入姓名", trigger: "blur"},
        phone: { required: true,validator: validatePhone,trigger: "blur"},
      },
			timer: null,
			date: '-1',
			legal:false //是否为法人
    };
  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {
    isShow(val) {
			val == 7 || val == 5 ? this.btnTxt = '关闭' : this.btnTxt = '下一步'
      // if(val == 1){
      //   // 暂时隐藏通告
      //   this.isShow = 3
      // }
		},
		showModal(val){
			if(!val){
				clearInterval(this.timer);
			}
		}
	},
  methods: {
    // 获取个人信息
    getUserInfo() {
      userInfo({}).then((res) => {
        if (res && res.data.success) {
          this.subForm.companyId = res.data.data.companyId
					if(!res.data.data.needCertification && !res.data.data.companyId){
						this.showModal = false
						return
          }
          this.getRemain()
					this.legal = res.data.data.legal
					res.data.data.personalCertificationStatus == "Verify" ? this.current = 1 : this.current = 0
					res.data.data.companyCertificationStatus == "Verify" ? this.current = 2 : this.isShow = 1
          this.showModal = true
          if (this.current >0) {
            this.$store.commit('user/save',{done:true})
          }
        }
      });
    },
    // 获取个人核身认证地址
    getUserAuthUrl() {
      userAuthUrl().then((res) => {
        if (res && res.data.success) {
          // 个人认证结果轮询
          this.timer = window.setInterval(() => {
            setTimeout(() => {
              this.getUserAuthStatus(res.data.data.flowId);
            }, 1);
          }, 5000);
          window.open(res.data.data.url,500);
        }else {
					this.$Message.error(res.data.msg)
				}
      });
    },
    // 个人认证轮训
    getUserAuthStatus(id) {
      userAuthStatus({
        id: id,
      }).then((res) => {
        if (res && res.data.success) {
          if (res.data.data) {
						clearInterval(this.timer);
						this.current = 1
          }
        }
      })
    },
    // 获取企业核身认证地址
    getOrgAuthUrl() {
      orgAuthUrl().then((res) => {
        if (res && res.data.success) {
          // 企业认证结果轮询
          this.timer = window.setInterval(() => {
            setTimeout(() => {
              this.getOrgAuthStatus(res.data.data.flowId);
            }, 1);
					}, 5000);
					this.openPaymentAccount()
          window.open(res.data.data.url,500);
        }else {
					this.$Message.error(res.data.msg)
				}
      });
    },
    // 企业认证轮训
    getOrgAuthStatus(id) {
      orgAuthStatus({
        id: id,
      }).then((res) => {
        if (res && res.data.success) {
          if (res.data.data.status == 'Verify') {
						clearInterval(this.timer);
						this.current = 2
						this.legal = true
          }
        }
      })
		},
		// 创建用户
		creatUser(){
			this.$refs.subForm.validate((valid) => {
				if(valid) {
					this.subForm.password = this.randomPasswords()
					this.subForm.id = this.subForm.phone
					let data = _.cloneDeep(this.subForm)
					createCompanyUser(data).then( res => {
						if(res && res.data.success){
							this.isShow = 7
						}else {
							this.$Message.error(res.data.msg)
						}
					})
				}
			})
		},
		// 生成随机密码
		randomPasswords(){
			const pasArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','0','1','2','3','4','5','6','7','8','9']
			let x,password = ''
			for (let i=0; i<9; i++){
 				x = Math.floor(Math.random()*pasArr.length);
				password += pasArr[x];
			}
			return password
		},
		// 剩余不认证的天数
    getRemain() {
      remain({}).then((res) => {
        if (res && res.data.success) {
          this.date = res.data.data
          this.$store.commit('user/save',{certificationDate:res.data.data})
          console.log('this.$store',this.$store)
        }
      })
		},
		// 获取企业人员列表
    openPaymentAccount(){
      getCompanyMember({
        companyId: this.subForm.companyId
      }).then(res => {
        if( res && res.data.success ){
          let data = JSON.parse(res.data.data.value)
          this.table.data = data.userList
          if(data.userList.length > 1){
            let info = {}
            for (var i = 0; i < this.table.data.length; i++) {
			        if (this.table.data[i].id == decode(Cookies.get('user'))) {
								info = this.table.data[i]
								this.table.data.splice(i, 1)
		            break;
	            }
            }
          	this.table.data.unshift(info)
					}

        }
      })
		},
		// 修改员工角色
		setCharacterUpdate(id,v){
			characterUpdate({
				"characterPosition": v,
				"id": id
			}).then( res => {
				if(res && res.data.success){
					this.$Message.success('修改成功')
				}else {
					this.$Message.error(res.data.msg)
				}
			})
		},
    next() {
      switch (this.isShow) {
        case 1:
					this.isShow = 3;
          break;
        case 2:
          if (this.identity == 1) {
            this.isShow = 3;
          } else if (this.identity == 2) {
            this.isShow = 6;
          } else {
            this.$Message.error("请选择身份");
          }
          break;
        case 3:
          this.isShow = 4;
          break;
        case 4:
					if(this.current == 0){
						this.getUserAuthUrl();
					}else if(this.current == 1){
						this.getOrgAuthUrl();
					}else {
						// this.isShow = 5
            this.showModal = false
					}
					break;
				case 5:
          this.showModal = false
					break;
				case 6:
          this.creatUser()
					break;
				case 7:
          this.showModal = false
					break;
      }
    },
    // 复制密码
    copyPassword() {
      let input = document.getElementById("pwd");
      input.select();
      document.execCommand("copy");
      this.$Message.success("复制成功！");
    },
    show(flag) {
			if(flag){
				this.getUserInfo()
			}
    },
  },
};
</script>

<style lang="less">
.cer-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal-footer {
    border: none;
  }
  .ivu-modal {
    top: 0;
  }
  .logo {
    display: inline-block;
    width: 42px;
		float: right;
		margin-right: 22px;
    margin-top: -3px;
  }
  .content {
    font-size: 15px;
    color: #000;
    .icon {
      font-size: 32px;
    }
    .txt {
      text-indent: 2em;
      line-height: 28px;
    }
    .warning {
      color: #ff9100;
      font-weight: bold;
    }
    .choose {
      line-height: 40px;
      border-radius: 10px;
      border: 1px solid #ccc;
      color: #ccc;
      background: #fff;
      display: inline-block;
      width: 120px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
			margin: 30px;
			cursor: pointer;
    }
    .active {
      border-color: #fff2e2;
      color: #ff9100;
      background: #fff2e2;
    }
    .p-l50 {
      padding-left: 40px;
    }
    .label {
      display: inline-block;
      width: 80px;
      vertical-align: middle;
    }
    .iconfont {
      vertical-align: middle;
    }
    .iconfuzhi {
      color: #ff9100;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: bottom;
      font-size: 18px;
    }
    .info {
      vertical-align: middle;
    }
    .iconmima {
      font-size: 19px;
      margin-left: -2px;
    }
    #pwd {
      opacity: 0;
    }
  }
  .ivu-steps-item.ivu-steps-status-process .ivu-steps-head-inner {
    border-color: #ff9100;
    background-color: #ff9100;
  }
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner {
    border-color: #ff9100;
  }
  .ivu-steps-item.ivu-steps-status-finish
    .ivu-steps-head-inner
    > .ivu-steps-icon,
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner span {
    color: #ff9100;
  }
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-tail > i:after {
    background-color: #ff9100;
  }
  .ivu-form-item-content {
    display: inline-block;
    width: 300px;
    margin-left: 0 !important;
  }

  button {
    background: #ff9100;
    border-color: #ff9100;
    width: 50%;
    margin: 0 auto;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// certification-modal.vue?36514426